export const copyFromClipboard = async () => {
  let content
  const clipboard = await navigator.clipboard.readText()
  if (!clipboard) {
    return null
  }
  try {
    content = JSON.parse(clipboard)
  } catch (error) {
    console.warn('Error copying to clipboard: ', error.message, '')
  }

  return content
}

// Copy text that is not known yet — a value a request is still fetching — to
// the clipboard, from inside the click that asked for it
// (`el.call('copyTextWhenReady', promiseOfText)`, INVITE-MAGIC-LINK-1).
//
// A page may write the clipboard only during a user gesture, and Safari ends
// the gesture at the first `await`: a click that waits for the server and THEN
// calls `writeText` copies nothing, silently. A `ClipboardItem` whose value is
// a PROMISE is the exception the platform makes for exactly this: the write
// starts inside the gesture and fills in when the promise settles (Safari,
// Chrome, Firefox 127+). Without ClipboardItem the text is awaited and written
// as plain text.
//
// Call it SYNCHRONOUSLY in the click handler, before any `await`.
// `textPromise` resolves to the text (or rejects). Returns a promise of `true`
// when the clipboard took the text, else `false`; never rejects, never throws.
// The text is never logged. Self-contained (FA204).
export const copyTextWhenReady = (textPromise) => {
  const clip = typeof navigator !== 'undefined' && navigator ? navigator.clipboard : null
  if (!clip) return Promise.resolve(false)
  try {
    if (typeof ClipboardItem === 'function' && typeof clip.write === 'function') {
      const blob = Promise.resolve(textPromise).then((text) => {
        if (!text) throw new Error('nothing to copy')
        return new Blob([String(text)], { type: 'text/plain' })
      })
      return clip.write([new ClipboardItem({ 'text/plain': blob })]).then(
        () => true,
        () => false
      )
    }
  } catch (_) {
    // A ClipboardItem that refuses a promise value: the plain-text path below.
  }
  return Promise.resolve(textPromise)
    .then((text) =>
      text && typeof clip.writeText === 'function'
        ? clip.writeText(String(text)).then(() => true)
        : false
    )
    .catch(() => false)
}
